import merge from "lodash/merge";
import api from "./api";
import config from "../config";

export default {
  fetchAll(apiKey, options) {
    if (options && options.conditions) {
      options.conditions = JSON.stringify(options.conditions);
    }
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `people`,
          allow_cache: true,
          qs: options,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response.people);
        }
      );
    });
  },

  fetchOne(apiKey, id) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `people/${id}`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchAutocomplete(apiKey, query) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `people/autocomplete?query=${query}`,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  edit(apiKey, id, values) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `people/${id}`,
          json: values,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  create(apiKey, values) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `people/admin_create`,
          json: values,
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  forgotPassword(apiKey, id, event_bucket) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `people/${id}/forgot_password`,
          json: {
            event_bucket: event_bucket
          },
          api_key: apiKey
        },
        function(err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/PersonUtil.js